// @ts-strict-ignore
import { useEffect, useState } from 'react'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { PaginationPaging } from 'types/pagination'

export const usePaginationPagingPersist = (pagination: PaginationPaging | undefined) => {
  const [paging, setPaging] = useState<PaginationPaging>()
  const showPagination: boolean = paging?.total <= MIN_PAGINATION_SIZE

  useEffect(() => {
    if (pagination) {
      setPaging(pagination)
    }
  }, [pagination])

  return {
    paging,
    showPagination,
  }
}
